import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiservicesService } from '../services/apiservices.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  public loginForm: FormGroup;
  public loader: boolean = false;
  private userIp: any = null;
  public env_name = environment.environment_name;
  submitted = false;

  hide = true;
  constructor(
    private apiService: ApiservicesService,
    private cookieService: CookieService,
    public router: Router,
    public matSnackBar: MatSnackBar
  ) {
    this.loginForm = new FormGroup({
      email: new FormControl(''),
      password: new FormControl(''),
    });
  }
  ngOnInit() {
    this.apiService
      .getHttpDataWithoutBaseUrl('https://api.ipify.org?format=json')
      .subscribe({
        next: (getIpResp) => {
          this.userIp = getIpResp?.ip ? getIpResp?.ip : '';
        },
      });
    this.apiService.getHttpData('user/build-connection').subscribe({
      next: (getIpResp) => {
      },
    });
  }

  handleKeyUp(e: any) {
    if (e.keyCode === 13) {
      this.login();
    }
  }

  login() {
    this.submitted = true;
    if (this.loginForm.valid) {

      let dataobj = {
        username: this.loginForm.value.email,
        password: this.loginForm.value.password,
      };


      this.loader = true;
      // let ipresponse = {
      //   "ip": "103.101.212.222",
      //   "city": "Bhātpāra",
      //   "region": "West Bengal",
      //   "country": "IN",
      //   "loc": "22.8664,88.4011",
      //   "org": "AS23860 Alliance Broadband Services Pvt. Ltd.",
      //   "postal": "743123",
      //   "timezone": "Asia/Kolkata"
      // }

      const ipUrl = `https://ipinfo.io/${this.userIp ? this.userIp : ''
        }?token=a8778567b02081`;

      this.apiService.getHttpDataWithoutBaseUrl(ipUrl).subscribe({
        next: (ipresponse) => {

          const finalLoginPayload = { ...dataobj, ipInfo: ipresponse };

          this.apiService
            .getHttpDataPost('user/login', finalLoginPayload)
            .subscribe({
              next: (response) => {

                if (
                  response?.results?.ChallengeName == 'NEW_PASSWORD_REQUIRED'
                ) {


                  if (response?.results?.userData?.is_diviner == 1 && this.env_name === 'main') {
                    this.matSnackBar.open(
                      'This feature will be accessible to Diviner accounts starting February 1, 2026.',
                      'Ok',
                      {
                        duration: 5000,
                      }
                    );
                  } else if (
                    (response?.results?.userData?.is_perennial_mandalism == 1 || response?.results?.userData?.user_type === 'is_Perennial_Mandalism') && this.env_name === 'main'
                  ) {
                    this.matSnackBar.open(
                      'You will be notified when access to this dashboard becomes available.',
                      'Ok',
                      {
                        duration: 5000,
                      }
                    );
                  } else {
                    const expirationDate = new Date();
                    expirationDate.setMinutes(expirationDate.getMinutes() + 60);
                    let obj = {
                      email: dataobj.username,
                      token: response.results.Session,
                    };
                    this.cookieService.set('session', JSON.stringify(obj), {
                      path: '/',
                      expires: expirationDate,
                    });
                    this.router.navigateByUrl(`/force-password-change`);
                  }
                  this.loader = false;
                } else {
                  this.cookieService.set('login_user_details', JSON.stringify(response.results), { path: '/' });
                  this.cookieService.set('loggedin_user', 'true', {
                    path: '/',
                  });

                  // Legacy toolkit fetch commented out
                  // this.apiService
                  //   .getHttpData('astro_decan_new_infos/get-astro-toolkit')
                  //   .subscribe({
                  //     next: (astroResponse) => {
                  //       let obj = {
                  //         access_key: astroResponse.results.access_key,
                  //         secret_key: astroResponse.results.secret_key,
                  //       };
                  //       this.cookieService.set(
                  //         'astro_key_values',
                  //         JSON.stringify(obj),
                  //         { path: '/' }
                  //       );
                  //     },
                  //     error: (error) => {
                  //       console.log('Error fetching astro toolkit:', error);
                  //     },
                  //   });

                  this.loader = false;

                  this.matSnackBar.open(response.message, 'Ok', {
                    duration: 3000,
                  });

                  const userType = response.results.userinfo.user_type;

                  if (userType === 'is_admin') {

                    if (sessionStorage.getItem('lastroute')) {
                      const lastRoute = sessionStorage.getItem('lastroute');

                      this.router.navigateByUrl(`${lastRoute}`);

                      setTimeout(() => {
                        sessionStorage.removeItem('lastroute');
                      }, 1500);
                    } else {
                      this.router.navigateByUrl(`/admin-dashboard`);
                    }
                  } else if (
                    userType === 'is_astrologer' ||
                    userType === 'is_tarotreader'
                  ) {
                    this.router.navigateByUrl(`/astrologer-dashboard`);
                  } else if (
                    userType === 'is_social_advo' ||
                    userType === 'is_customer_socialadvo' ||
                    userType === 'is_customer'
                  ) {
                    this.router.navigateByUrl(`/customer-dashboard`);
                  } else if (userType === 'is_affiliate') {
                    this.router.navigateByUrl(`/affiate-dashboard`);
                  } else if (response.results.userinfo.is_diviner === 1) {
                    if (this.env_name === 'main') {
                      this.matSnackBar.open(
                        'This feature will be accessible to Diviner accounts starting February 1, 2026.',
                        'Ok',
                        { duration: 5000 }
                      );

                      this.cookieService.delete('login_user_details', '/');
                      this.cookieService.delete('loggedin_user', '/');
                    } else {
                      this.router.navigateByUrl(
                        `/divination-certification-dashboard`
                      );
                    }
                  } else if (
                    userType === 'is_Perennial_Mandalism' ||
                    response.results.userinfo.is_perennial_mandalism === 1
                  ) {
                    if (this.env_name === 'main') {
                      this.matSnackBar.open(
                        'You will be notified when access to this dashboard becomes available.',
                        'Ok',
                        { duration: 5000 }
                      );

                      this.cookieService.delete('login_user_details', '/');
                      this.cookieService.delete('loggedin_user', '/');
                    } else {
                      this.router.navigateByUrl(
                        `/perennial-mandalism-dashboard`
                      );
                    }
                  } else if (userType === 'customer') {
                    this.router.navigateByUrl(`/customer`);
                  }
                }
              },
              error: (error) => {
                this.loader = false;
                this.matSnackBar.open(error.message, 'Ok', {
                  duration: 5000,
                });
              },
            });
        },
        error: (ipError) => {
          this.loader = false;
          this.matSnackBar.open('Unable to fetch IP info', 'Ok', {
            duration: 5000,
          });
        },
      });
    } else {
      console.log('Login form is invalid');
    }
  }

  fetchVarification = (data: any) => { };
  // keyDownFunction(event) {
  //   if (event.keyCode === 13) {
  //     // if (event.key === "Enter") {}
  //     //alert('you just pressed the enter key');
  //     // rest of your code
  //     this.login();
  //     this.hide = false;

  //   }
  // }
}
